<ng-container [formGroup]="form">
  <app-table-header-column name="oc" size="medium">
    <span content>
      Nº da Ordem
      <app-filter-button [column]="'orderNumber'"
        [menu]="orderNumberFilterMenu" [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn" #orderNumberFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #orderNumberFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por número da ordem</h4>
      <button (click)="sort('orderNumber', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['orderNumber'] && sortDirection === 'DESC'"></i>
      </button>
      <button (click)="sort('orderNumber', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['orderNumber'] && sortDirection === 'ASC'"></i>
      </button>
      <mat-form-field appearance="outline">
        <input matInput placeholder="Número da Ordem" formControlName="search" autocomplete="off">
      </mat-form-field>
      <section class="actions">
        <button mat-stroked-button class="gray-1" (click)="clearFilters(orderNumberFilterBtn.menuTrigger, 'orderNumber')">Limpar</button>
        <button mat-raised-button class="primary-1" (click)="applyFilters(orderNumberFilterBtn.menuTrigger)">Salvar</button>
      </section>
    </div>
  </mat-menu>

  <app-table-header-column name="in-timestamp" size="small">
    <span content>
      Data/Hora de Entrada
      <app-filter-button [column]="'issuedAt'"
        [menu]="issuedAtFilterMenu" [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn" #issuedAtFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #issuedAtFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por data de entrada</h4>
      <button (click)="sort('issuedAt', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['issuedAt'] && sortDirection === 'DESC'"></i>
      </button>
      <button (click)="sort('issuedAt', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['issuedAt'] && sortDirection === 'ASC'"></i>
      </button>
      <mat-form-field appearance="outline">
        <mat-label>Data inicial</mat-label>
        <input matInput [matDatepicker]="startDatePicker" formControlName="startDate" required [max]="maxDate" disabled
          (dateChange)="onStartDateChange()">
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker disabled="false"></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Data final</mat-label>
        <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" required [max]="maxDate" [min]="minDate" disabled
          (dateChange)="onEndDateChange()">
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker disabled="false"></mat-datepicker>
      </mat-form-field>
      <section class="actions">
        <button mat-stroked-button class="gray-1" (click)="clearFilters(issuedAtFilterBtn.menuTrigger, 'issuedAt')">Limpar</button>
        <button mat-raised-button class="primary-1" (click)="applyFilters(issuedAtFilterBtn.menuTrigger)" [disabled]="isIssuedAtSaveBtnDisabled">Salvar</button>
      </section>
    </div>
  </mat-menu>

  <app-table-header-column name="document" size="small">
    <span content>
      Tipo de entrada
      <app-filter-button [column]="'entrySource'"
        [menu]="entrySourceFilterMenu" [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn" #entrySourceFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #entrySourceFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por tipo de entrada</h4>
      <mat-form-field class="dropdown" appearance="outline">
        <mat-label>Tipo de entrada</mat-label>
        <mat-select formControlName="entrySource">
          <mat-option *ngFor="let option of entrySourceOptions" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>
      <section class="actions">
        <button mat-stroked-button class="gray-1" (click)="clearFilters(entrySourceFilterBtn.menuTrigger, 'entrySource')">Limpar</button>
        <button mat-raised-button class="primary-1" (click)="applyFilters(entrySourceFilterBtn.menuTrigger)">Salvar</button>
      </section>
    </div>
  </mat-menu>

  <app-table-header-column name="status" size="small">
    <span content>
      Status
      <app-filter-button [column]="'state'"
        [menu]="stateFilterMenu" [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn" #stateFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #stateFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por status</h4>
      <mat-form-field class="dropdown" appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select formControlName="state">
          <mat-option *ngFor="let option of stateOptions" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>
      <section class="actions">
        <button mat-stroked-button class="gray-1" (click)="clearFilters(stateFilterBtn.menuTrigger, 'state')">Limpar</button>
        <button mat-raised-button class="primary-1" (click)="applyFilters(stateFilterBtn.menuTrigger)">Salvar</button>
      </section>
    </div>
  </mat-menu>
</ng-container>
